import { format } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import { TransferBlockchainData } from '../types';

type FilterTransferListParams = {
  transferList: TransferBlockchainData[],
  status?: string,
  amountMin?: number,
  amountMax?: number
}

export const filterTransferList = ({ transferList, status, amountMin, amountMax }: FilterTransferListParams) => {
  const wireTranferFilteredByStatus = transferList.filter((wireTransfer) => {
    if (status) {
      return wireTransfer.document?.status.toLowerCase() === status.toLowerCase();
    }

    return true;
  });

  const tranferFilteredByAmountLimits = wireTranferFilteredByStatus.filter((transfer) => {
    let isInLimit = true;
    const totalAmount = transfer.document?.instructions.reduce(
      (acc, element) => acc + element.amount,
      0
    ) || 0;

    if (amountMin && amountMax) {
      return totalAmount >= amountMin && totalAmount <= amountMax;
    }

    if (amountMin) {
      isInLimit = totalAmount >= amountMin;
    }

    if (amountMax) {
      isInLimit = totalAmount <= amountMax;
    }

    return isInLimit;
  });

  return tranferFilteredByAmountLimits;
};

type GetComparationFnParams = {
  property: string,
  operator: string
}

export const getComparationFn = ({ property, operator }: GetComparationFnParams) => {
  let comparationFn: ((a: TransferBlockchainData, b: TransferBlockchainData) => number) | undefined;

  if (property === 'amount') {
    comparationFn = (a, b) => {
      const totalA = a.document?.instructions.reduce(
        (acc, element) => acc + element.amount,
        0
      ) || 0;
      const totalB = b.document?.instructions.reduce(
        (acc, element) => acc + element.amount,
        0
      ) || 0;

      if (totalA > totalB) {
        if (operator === 'descending') return -1;
        return 1;
      }
      if (totalA < totalB) {
        if (operator === 'descending') return 1;
        return -1;
      }
      return 0;
    };
  }
  return comparationFn;
};

export const convertMsToDate = ({ ms, formatValue = 'MMMM dd, yyyy', language }: { ms: number, language: string, formatValue?: string }) => {
  const locales = {
    en: enUS,
    es,
  };

  const locale = locales[language];
  return format(new Date(ms), formatValue, { locale });
};